// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import styles from '@app/features/app/components/dialogs/components/PurchaseDisclaimer.module.css';
import {ExternalLink} from '@app/features/app/components/shared/ExternalLink';
import {Trans} from '@lingui/react/macro';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';
export const PurchaseDisclaimer = observer(
	({isPremium = false, align = 'center'}: {isPremium?: boolean; align?: 'left' | 'center'}) => {
		const terms = <ExternalLink href={Routes.terms()}>Terms of Service</ExternalLink>;
		const privacy = <ExternalLink href={Routes.privacy()}>Privacy Policy</ExternalLink>;
		return (
			<p className={clsx(styles.disclaimer, align === 'center' ? styles.center : styles.left)}>
				{isPremium ? (
					<Trans>
						By purchasing, you agreed to our {terms} and {privacy}.
					</Trans>
				) : (
					<Trans>
						By purchasing, you agree to our {terms} and {privacy}.
					</Trans>
				)}{' '}
				<Trans>
					You can self-serve refund your most recent purchase within 3 days of payment, once every 30 days; if it was
					tied to a subscription, that subscription is cancelled at the same time. We don't otherwise offer refunds.
					EU/EEA buyers must waive the 14-day right of withdrawal at checkout to access purchased content immediately.
					Chargebacks result in permanent account bans — if you want a refund, please use the in-app refund button or
					contact us first! Payment information is securely handled by Stripe — we never have access to your full card
					number.
				</Trans>
			</p>
		);
	},
);
